import {
	FaCss3Alt,
	FaGithub,
	FaHtml5,
	FaReact,
	FaSass,
	FaYarn,
	FaFileContract,
	FaRegHandshake
} from "react-icons/fa";
import { DiJavascript1 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import {
	SiAdobephotoshop,
	SiNextdotjs,
	SiTypescript,
	SiRedux,
	SiHiveBlockchain,
	SiLetsencrypt,
	SiSolidity,
	SiDwavesystems,
	SiProtocolsdotio,
	SiWeb3Dotjs,
} from "react-icons/si";

export const SkillsData = [
	{
		name: "HTML",
		icon: <FaHtml5 />,
	},
	{
		name: "CSS",
		icon: <FaCss3Alt />,
	},
	{
		name: "Javascript",
		icon: <DiJavascript1 />,
	},
	{
		name: "TypeScript",
		icon: <SiTypescript />,
	},
	{
		name: "React Js",
		icon: <FaReact />,
	},
	{
		name: "Next Js",
		icon: <SiNextdotjs />,
	},
	{
		name: "Redux",
		icon: <SiRedux />,
	},
	{
		name: "Sass",
		icon: <FaSass />,
	},
	{
		name: "Git",
		icon: <FaGithub />,
	},
	{
		name: "Yarn",
		icon: <FaYarn />,
	},
	{
		name: "Photoshop",
		icon: <SiAdobephotoshop />,
	},
	{
		name: "Blockchain Technology",
		icon: <SiHiveBlockchain />,
	},
	{
		name: "Cryptography",
		icon: <SiLetsencrypt />,
	},
	{
		name: "Solidity",
		icon: <SiSolidity />,
	},
	{
		name: "Consensus Algorithms",
		icon: <FaRegHandshake />,
	},
	{
		name: "Distributed Systems",
		icon: <SiDwavesystems />,
	},
	{
		name: "Smart Contracts",
		icon: <FaFileContract />,
	},
	{
		name: "DeFi Protocols",
		icon: <SiProtocolsdotio />,
	},
	{
		name: "Web3.js",
		icon: <SiWeb3Dotjs />,
	},
];
